module.exports = __webpack_public_path__ + "media/images/banner/tjt/sp/travel04_1280_1280_th-d36ea302e4ac32205b05dbe3dd2c0f5e.jpg";